import { z } from 'zod';

export const GetSeedingProductOptionsServiceRequestSchema = z
  .object({
    campaignId: z.number().int(),
    goodsNos: z.array(z.number().int()).min(1).max(50),
  })
  .describe('GetSeedingProductOptionsServiceRequest');

export type GetSeedingProductOptionsServiceRequest = z.infer<
  typeof GetSeedingProductOptionsServiceRequestSchema
>;

const OptionValueSchema = z.object({
  valueId: z.number().int(),
  name: z.string(),
  color: z.string().nullable().optional(),
  imageUrl: z.string().nullable().optional(),
});

const OptionGroupSchema = z.object({
  optionName: z.string(),
  values: z.array(OptionValueSchema),
});

const SkuSchema = z.object({
  skuId: z.number().int(),
  valueIds: z.array(z.number().int()),
  outOfStock: z.boolean(),
  extraPrice: z.number().int(),
});

const ExtraOptionGroupValueSchema = z.object({
  valueId: z.number().int(),
  name: z.string(),
  // BE 는 추가옵션 값 가격을 `price` 로 내려준다 (SKU 의 `extraPrice` 와 필드명이 다름).
  price: z.number().int(),
  outOfStock: z.boolean(),
});

const ExtraOptionGroupSchema = z.object({
  extraOptionId: z.number().int(),
  name: z.string(),
  required: z.boolean(),
  sequence: z.number().int(),
  values: z.array(ExtraOptionGroupValueSchema),
});

export const SeedingProductOptionsItemSchema = z
  .object({
    goodsNo: z.number().int(),
    options: z.array(OptionGroupSchema),
    skus: z.array(SkuSchema),
    extraOptions: z.array(ExtraOptionGroupSchema),
  })
  .describe('SeedingProductOptionsItem');

export type SeedingProductOptionsItem = z.infer<typeof SeedingProductOptionsItemSchema>;

export const GetSeedingProductOptionsServiceResponseSchema = z
  .object({
    items: z.array(SeedingProductOptionsItemSchema),
  })
  .describe('GetSeedingProductOptionsServiceResponse');

export type GetSeedingProductOptionsServiceResponse = z.infer<
  typeof GetSeedingProductOptionsServiceResponseSchema
>;
